import { Injectable } from '@angular/core';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class PayrollGridComponentConfig {
  public enableLaborAllocations: boolean;

  constructor(private appConfig: AppConfigService) {
    this.enableLaborAllocations = this.appConfig.getConfig().EnableLaborAllocations || false;
  }
}
